import React from 'react';
import PropTypes from 'prop-types';
import { CloseIcon } from 'assets/svgs';
import cx from 'classname';
import styles from './modal.module.scss';
import classname from 'classname';

const Modal = ({ handleClose, showModal, maxWidth, children, plain }) => {
  return (
    <div
      className={cx(
        styles.Modal,
        showModal ? styles.ModalShow : styles.ModalHide
      )}
    >
      <section
        className={classname(styles.ModalMain, plain ? styles.plain : '')}
        style={{ maxWidth: `${maxWidth}px` }}
      >
        {!plain && (
          <button
            type="button"
            onClick={handleClose}
            className={styles.ModalCloseIcon}
          >
            <CloseIcon />
          </button>
        )}

        {children}
      </section>
    </div>
  );
};

Modal.propTypes = {
  handleClose: PropTypes.func,
  showModal: PropTypes.bool,
};

export default Modal;
